export const nav = {
    permissao: 'hdocs.arquivos:ver',
    section: 'Configuracao',
    title: 'Arquivos',
    icon: 'folder_open',
    route: '/arquivos',
    sequence: 16, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/arquivos',
        name: 'arquivos',
        component: () => import('./pages/ArquivosPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.arquivos:ver' },
    },
];
